import React from "react";
import {
  Document,
  Page,
  Text,
  StyleSheet,
  View,
  Image,
  Font,
} from "@react-pdf/renderer";
import Logo from "./assets/SavartLogo.png";
import RobotoRegular from "./assets/fonts/Roboto-Regular.ttf";
import RobotoBold from "./assets/fonts/Roboto-Bold.ttf";
import { getToday } from "../utils/varialbles";
import Html from "react-pdf-html";

Font.register({
  family: "Roboto-Bold",
  fonts: [
    {
      src: RobotoBold,
      fontWeight: "bold",
    },
  ],
});

Font.register({
  family: "Roboto-Regular",
  fonts: [
    {
      src: RobotoRegular,
      fontWeight: "normal",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 30,
    paddingRight: 30,
    // fontFamily: "Roboto-Regular",
  },

  image: {
    width: "30%",
    position: "absolute",
    right: -30,
    opacity: 0.5,
  },
  date: {
    textAlign: "left",
    marginTop: 10,
    fontSize: 10,
  },
  title: {
    fontSize: 22,
    marginTop: 50,
    marginBottom: 10,
    // fontWeight: "bold",
    color: "#2421AB",
    fontFamily: "Roboto-Bold",
  },
  title2: {
    fontSize: 18,
    marginTop: 35,
    marginBottom: 10,
    // fontWeight: "bold",
    color: "#2421AB",
    fontFamily: "Roboto-Bold",
  },
  subtitle: {
    fontSize: 12,
    marginBottom: 10,
    color: "#595959",
  },
  subtitle2: {
    fontSize: 12,
    marginBottom: 5,
    color: "#595959",
  },
  // notesContainer: {
  //   marginTop: 20,
  // },
  // notesHeading: {
  //   fontWeight: "bold",
  //   fontSize: 14,
  //   marginBottom: 6,
  // },
  // notesText: {
  //   fontSize: 10,
  //   marginBottom: 8,
  //   marginLeft: 10,
  // },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,

    borderColor: "#9CC2E5",
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
    backgroundColor: "#EFF5FB",
  },
  tableRowHeading: {
    margin: "auto",
    flexDirection: "row",
    backgroundColor: "#DEEAF6",
    fontSize: 12,
  },
  tableCol1: {
    width: "40%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderColor: "#9CC2E5",
    textAlign: "left",
    marginTop: "-1px",
    marginBottom: "-1px",
  },
  tableCol2: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderColor: "#9CC2E5",
    marginTop: "-1px",
    marginBottom: "-1px",
  },
  tableCol3: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderColor: "#9CC2E5",
    marginTop: "-1px",
    marginBottom: "-1px",
  },
  tableCol4: {
    width: "20%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderColor: "#9CC2E5",
    marginTop: "-1px",
    marginBottom: "-1px",
  },

  tableCol5: {
    width: "20%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderColor: "#9CC2E5",
    marginTop: "-1px",
    marginBottom: "-1px",
  },

  tableLastCol1: {
    width: "80%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderColor: "#9CC2E5",
    marginTop: "-1px",
    marginBottom: "-1px",
  },
  tableLastCol2: {
    width: "20%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderColor: "#9CC2E5",
    marginTop: "-1px",
    marginBottom: "-1px",
  },
  tableLastCell: {
    // margin: "auto",
    // marginTop: 5,
    fontSize: 12,
    padding: 5,
    textAlign: "right",
    fontFamily: "Roboto-Bold",
  },
  tableLastCell2: {
    // margin: "auto",
    // marginTop: 5,
    fontSize: 12,
    padding: 5,
    textAlign: "center",
    fontFamily: "Roboto-Bold",
  },
  tableCellColumn1: {
    // margin: "auto",
    // marginTop: 5,
    fontSize: 10,
    padding: 5,
  },
  tableCell: {
    // margin: "auto",
    // marginTop: 5,
    fontSize: 10,
    padding: 5,
    textAlign: "center",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 15,
    left: 30,
    right: 30,
    color: "#7F7F7F",
  },
  container: {
    marginHorizontal: 20,
    marginTop: 10,
  },

  notesTitle: {
    fontSize: 13,
    fontFamily: "Roboto-Bold",
    marginBottom: 5,
    marginTop: 15,
  },
  listItem: {
    flexDirection: "row",
    marginBottom: 5,
  },
  number: {
    fontSize: 12,
    marginRight: 5,
    color: "#595959",
  },
  notesText: {
    flex: 1,
    flexWrap: "wrap",
    fontSize: 12,
    color: "#595959",
  },
  footerText: {
    marginTop: 20,
    textAlign: "center",
    fontSize: 8,
    color: "#808080",
  },
  notesContainer: {
    height: 200,
  },
  customHtmlText: {
    fontSize: 12,
  },
});

// const currentDate = new Date();

// const options = { day: "2-digit", month: "2-digit", year: "numeric" };
// const formattedDate = currentDate.toLocaleDateString("en-GB", options);

const formattedDate = getToday();

export const ExitPlan = ({
  selltable,
  // buytable,
  custname,
  pdftextabovetable,
  pdftextbelowtable,
}) => {
  //Sell Table
  const sellAmount = selltable.reduce((total, currentValue) => {
    return total + currentValue.amount;
  }, 0);

  const sellTableTotal = sellAmount.toLocaleString("en-IN");

  //Buy Table
  // const buyAmount = buytable.reduce((total, currentValue) => {
  //   return total + currentValue.amount;
  // }, 0);

  // const buyTableTotal = buyAmount.toLocaleString("en-IN");

  function formatText(text) {
    if (!text) {
      return ""; // Return an empty string if the input text is empty or null
    }

    return text
      .split("<p>")
      .join('<p style="color: #595959;">')
      .split("<strong>")
      .join('<span style="font-family: Roboto-Bold">')
      .split("</strong>")
      .join("</span>");
  }

  var formattedTextAbove = formatText(pdftextabovetable);
  var formattedTextBelow = formatText(pdftextbelowtable);

  return (
    <>
      <Document>
        <Page style={styles.page}>
          <View style={styles.imageContainer}>
            <Image style={styles.image} src={Logo} />
          </View>
          <Text style={styles.date}>{formattedDate}</Text>
          <Text style={styles.title}>Exit Plan</Text>
          {/* Re-balancing Plan */}
          <Text style={styles.subtitle}>
            This rebalancing plan has been crafted with love & care for{" "}
            <span style={{ fontFamily: "Roboto-Bold" }}>{custname}</span> by
            Savart.
          </Text>
          {/* <Text style={styles.subtitle2}>
            The first table includes the details of the securities that you can{" "}
            <span style={{ fontFamily: "Roboto-Bold" }}>“sell”</span>. The
            second table contains the details of the securities that you can{" "}
            <span style={{ fontFamily: "Roboto-Bold" }}>“buy”</span> to redeploy
            the realized amount from the sold securities.
          </Text> */}
          <Html style={styles.customHtmlText}>{formattedTextAbove}</Html>
          <View style={styles.table}>
            <View style={styles.tableRowHeading}>
              <View style={styles.tableCol1}>
                <Text
                  style={{
                    // margin: "auto",
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "left",
                  }}
                >
                  Investment Name
                </Text>
              </View>
              <View style={styles.tableCol2}>
                <Text
                  style={{
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  Action
                </Text>
              </View>
              <View style={styles.tableCol3}>
                <Text
                  style={{
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  Type
                </Text>
              </View>
              <View style={styles.tableCol4}>
                <Text
                  style={{
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  ISIN No/Ticker
                </Text>
              </View>
              <View style={styles.tableCol5}>
                <Text
                  style={{
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  Amount
                </Text>
              </View>
            </View>
            {selltable.map((item, index) => (
              <View key={index} style={styles.tableRow} wrap={false}>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCellColumn1}>{item.stockname}</Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>Sell</Text>
                </View>
                <View style={styles.tableCol3}>
                  <Text style={styles.tableCell}>{item.assettype}</Text>
                </View>
                <View style={styles.tableCol4}>
                  <Text style={styles.tableCell}>{item.ISINCode}</Text>
                </View>
                <View style={styles.tableCol5}>
                  <Text style={styles.tableCell}>{item.amount}</Text>
                </View>
              </View>
            ))}
            <View style={styles.tableRow}>
              <View style={styles.tableLastCol1}>
                <Text style={styles.tableLastCell}>Total Sell Amount</Text>
              </View>
              <View style={styles.tableLastCol2}>
                <Text style={styles.tableLastCell2}>{sellTableTotal}</Text>
              </View>
            </View>
          </View>

          <Html style={styles.customHtmlText}>{formattedTextBelow}</Html>

          {/*  */}
          {/*  */}

          {/* <Text style={styles.title2}>Investment Plan</Text>
          <View style={styles.table}>
            <View style={styles.tableRowHeading}>
              <View style={styles.tableCol1}>
                <Text
                  style={{
                    // margin: "auto",
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "left",
                  }}
                >
                  Investment Name
                </Text>
              </View>
              <View style={styles.tableCol2}>
                <Text
                  style={{
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  Action
                </Text>
              </View>
              <View style={styles.tableCol3}>
                <Text
                  style={{
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  Type
                </Text>
              </View>
              <View style={styles.tableCol4}>
                <Text
                  style={{
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  ISIN No/Ticker
                </Text>
              </View>
              <View style={styles.tableCol5}>
                <Text
                  style={{
                    fontFamily: "Roboto-Bold",
                    marginTop: 5,
                    padding: 5,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  Amount
                </Text>
              </View>
            </View>
            {buytable.map((item, index) => (
              <View key={index} style={styles.tableRow} wrap={false}>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCellColumn1}>{item.stockname}</Text>
                </View>
                <View style={styles.tableCol2}>
                  <Text style={styles.tableCell}>Buy</Text>
                </View>
                <View style={styles.tableCol3}>
                  <Text style={styles.tableCell}>{item.assettype}</Text>
                </View>
                <View style={styles.tableCol4}>
                  <Text style={styles.tableCell}>{item.ISINCode}</Text>
                </View>
                <View style={styles.tableCol5}>
                  <Text style={styles.tableCell}>{item.amount}</Text>
                </View>
              </View>
            ))}
            <View style={styles.tableRow}>
              <View style={styles.tableLastCol1}>
                <Text style={styles.tableLastCell}>
                  Total Investment Amount
                </Text>
              </View>
              <View style={styles.tableLastCol2}>
                <Text style={styles.tableLastCell2}>{buyTableTotal}</Text>
              </View>
            </View>
          </View> */}

          <View style={styles.notesContainer} wrap={false}>
            <Text style={styles.notesTitle}>NOTES:</Text>
            <View style={styles.container}>
              <View style={styles.listItem}>
                <Text style={styles.number}>1.</Text>
                <Text style={styles.notesText}>
                  The above investments can be made with a slight delay or
                  change in price as our portfolios are not perturbed by
                  short-term volatility.
                </Text>
              </View>
              <View style={styles.listItem}>
                <Text style={styles.number}>2.</Text>
                <Text style={styles.notesText}>
                  In case of stocks, the investment can be made either from NSE
                  or BSE through your demat account.
                </Text>
              </View>
              <View style={styles.listItem}>
                <Text style={styles.number}>3.</Text>
                <Text style={styles.notesText}>
                  If you require any assistance regarding your investment,
                  please call on 99666 93655 or write to us at
                  delight@savart.com for a swift response.
                </Text>
              </View>
            </View>
          </View>
          <View style={styles.pageNumber} wrap={false}>
            <Text>
              Equity investments are subject to market risks. Any projections or
              estimates shared here are for planning purposes only and must not
              be construed as a guarantee of returns. Historical returns may not
              be a guarantee of future performance, patience & discipline are
              required. The investments will commence only after all compliance
              & due diligence procedures are completed.
            </Text>
            <Text style={styles.footerText}>
              Copyright 2023 Savart is owned by Svobodha Infinity Investment
              Advisors Private Limited, Hyderabad - 500029
            </Text>
          </View>
        </Page>
      </Document>
    </>
  );
};

export default ExitPlan;
